// extracted by mini-css-extract-plugin
module.exports = {"scrollTop":"scrolltotop-module--scrollTop--3YO0r","fadeIn":"scrolltotop-module--fadeIn--39Ams"};